"use client";

import { motion, useMotionValue, useTransform, animate, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

export default function Counter({
  from = 1,
  to,
  duration,
  prefix = "",
  suffix = "",
  fontSize,
  color,
  className = "",
  style,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false }); // <--- re-runs every time
  const count = useMotionValue(from);
  const rounded = useTransform(count, (latest) => Math.round(latest));

  useEffect(() => {
    if (isInView) {
      const controls = animate(count, to, { duration });
      return () => controls.stop();
    } else {
      count.set(from); // reset when out of view
    }
  }, [isInView, count, from, to, duration]);

  return (
    <motion.span
      ref={ref}
      className={className}
      style={{
        fontSize,
        color,
        fontFamily: "inherit",
        ...style,
      }}
    >
      {prefix}
      <motion.span>{rounded}</motion.span>
      {suffix}
    </motion.span>
  );
}
